export enum EnumTenants {
  Ressif = "fade294a-b9a9-4bd6-a803-c067d2bd8ef3",
  SSTRN = "9f66153a-1411-482f-9c63-2fc4cb595634",
  ASIA = "6fa4b9be-9411-48e6-879c-53505fae2a8c",
  ACTIS = "c341c9a0-e03a-4b11-be87-d8bbfea82399"
}